<template>
  <div>
    <InputMoney
        v-model="value_cash"
        label="Preço"
        name="value_cash"
        :errors="errors"
    />
    <InputMoney
        v-model="value_old"
        label="Preço Promocional"
        name="value_old"
        :errors="errors"
    />
    <InputNumber
        v-model="quantity"
        label="Quantidade Pague"
        name="quantity"
        :errors="errors"
    />
    <InputMoney
        v-model="unitary_value"
        label="Preço Unitário"
        name="unitary_value"
        :errors="errors"
    />
  </div>
</template>
<script>
import InputMoney from "../inputs/InputMoney.vue";
import InputNumber from "../inputs/InputNumber.vue";

export default {
  name: "DePorUnitatioEmbalagem",
  components: {InputNumber, InputMoney},
  data() {
    return {
      errors: [],
      quantity: null,
      value_old: null,
      value_cash: null,
      unitary_value: null,
    }
  },

  watch: {
    value_old() {
      this.calculate();
    },
    quantity() {
      this.calculate();
    },
    unitary_value() {
      this.calculate();
    },
  },

  methods: {
    calculate() {
      const quantity = this.parseToFloat(this.quantity);
      const valueOld = this.parseToFloat(this.value_old);

      if (valueOld <= 0 || quantity <= 0) {
        this.unitary_value = this.cleanValue(valueOld);
        return
      }

      const result = (valueOld / quantity);
      this.unitary_value = this.cleanValue(result)
    },

    cleanValue: function (value) {
      if (value) {
        value = value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
        value = (/\.[0-9]{1}$/g.test(value)) ? value + '0' : value;
        value = (/^\d+$/.test(value)) ? value + '.00' : value;
        value = value.toString().replace('.', ',');
      }
      return value;
    },

    parseToFloat(value) {
      if (value) {
        return parseFloat(value.replace(/\./g, '').replace(',', '.'));
      }
    },
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/carrefour/rules/DePorUnitatioEmbalagem.vue